import { render, staticRenderFns } from "./IconMaster.vue?vue&type=template&id=6b8c9948"
import script from "./IconMaster.vue?vue&type=script&lang=js"
export * from "./IconMaster.vue?vue&type=script&lang=js"
import style0 from "./IconMaster.vue?vue&type=style&index=0&id=6b8c9948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports